import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useUserStore } from '@/stores/user.store'
import { UserRoleId } from '@/types/authorisation/role-id.enum'

export const useIsPartnerWithoutOrganisations = computed(() => {
  const { roleId, user } = storeToRefs(useUserStore())

  return roleId.value === UserRoleId.PartnerAdmin && user.value.organisations && user.value.organisations.length === 0
})
